/**
 * TrackList Page
 * 
 * Route: /prioritization/cycles/:cycleId/tracks
 * Displays all tracks for a cycle. Wrapper around TrackIndex component.
 */

import { useParams } from 'react-router-dom';
import { TrackIndex } from '@/components/prioritization/TrackIndex';
import { useDegapProcessStore } from '@/stores/prioritization/degapProcessStore';

export function TrackList() {
  const { cycleId } = useParams<{ cycleId: string }>();
  
  const cycle = useDegapProcessStore(state => 
    state.cycles.find(c => c.id === cycleId)
  );

  if (!cycleId) {
    return (
      <div className="p-8 text-center">
        <p className="text-[var(--text-ter)]">No cycle ID provided</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <TrackIndex
        cycleId={cycleId}
        cycleName={cycle?.name || 'Cycle'}
      />
    </div>
  );
}

export default TrackList;
